import { render, staticRenderFns } from "./PropertyText.vue?vue&type=template&id=732e0ce7&scoped=true"
import script from "./PropertyText.vue?vue&type=script&lang=ts"
export * from "./PropertyText.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "732e0ce7",
  null
  
)

export default component.exports